import util from '@/util'
import mensagens from '@/util/mensagens'
import { obterImagem } from '@/util/imagem'
import { mapState, mapActions } from 'vuex'
import PainelAcesso from '@/components/layout/painelAcesso/PainelAcesso.vue'
import { loginMixin } from '@/modules/login/mixins'

export default {
  mixins: [loginMixin],
  name: 'pagamentoPendente',
  components: {
    PainelAcesso
  },
  computed: {
    ...mapState('auth', ['representanteLegal', 'dadosAlertaVencimento']),
    obterLogo () {
      return obterImagem('logo-mirt.svg')
    },
    arrayDadosAlertaVencimento () {
      if (util.valorVazio(this.dadosAlertaVencimento)) {
        return []
      }
      const dadosAlertaVencimento = JSON.parse(this.dadosAlertaVencimento)
      return dadosAlertaVencimento
    },
    temVencimentoReferenteContratoPrincipal () {
      const vencimentoReferenteContratoPrincipal = this.arrayDadosAlertaVencimento?.vencimentoReferenteContratoPrincipal
      return !!vencimentoReferenteContratoPrincipal
    }
  },
  data: () => {
    return {
      flagsDeControle: {
        manipulandoDados: {
          status: false,
          mensagem: ''
        }
      }
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions('auth', ['ActionSignOut']),

    async redirecionarParaPagamento () {
      const idFaturaVencida = this.arrayDadosAlertaVencimento?.idUltimaFatura

      if (!this.representanteLegal) {
        this.definirFlagManipulandoDados(true, mensagens.carregandoDadosEdicao)
        await this.logout()
        this.definirFlagManipulandoDados(false, '')
      }

      if (this.temVencimentoReferenteContratoPrincipal) {
        this.redirecionarVencimentoContratoPrincipal(idFaturaVencida)
      } else {
        this.redirecionarVencimentosAdicionais(idFaturaVencida)
      }
    },

    async logout () {
      try {
        await this.axios.post('/manager/conta/logout')
        this.ActionSignOut()
        this.$router.push({ name: 'loginLite' })
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaComunicacaoServidor)
      }
    },

    definirFlagManipulandoDados (status, mensagem) {
      this.flagsDeControle.manipulandoDados.status = status
      this.flagsDeControle.manipulandoDados.mensagem = mensagem
    }
  }
}
